export function MascaraTituloEleitor(value) {
    if (!value) return "";

    // remove tudo que não é número
    value = value.replace(/\D/g, "");

    // limita a 12 dígitos
    if (value.length > 12) value = value.slice(0, 12);

    // aplica a máscara: XXXX XXXX XXXX
    value = value.replace(/(\d{4})(\d)/, "$1 $2");
    value = value.replace(/(\d{4})(\d)/, "$1 $2");

    return value;
}